import React, { createContext, useState, useContext } from "react";

const MainContentContext = createContext();

export const MainContentProvider = ({ children }) => {
  const [mainContentData, setMainContentData] = useState({
    gstin: "",
    gstinData: [],
    gstinDetails: {},
    filingData: {},
    Avgdelaydata: {},
    gstr1FilingDates: [],
    gstr3bFilingDates: [],
    hsnData: [],
    prevDtls: [],
    rgdt: "N/A",
    aggreTurnOver: "N/A",
    legalName: "N/A",
    tradeName: "N/A",
    einvoiceStatus: "N/A",
    statusColor: "#B0B0B0",
    gstinCount: "N/A",
  });

  return (
    <MainContentContext.Provider value={{ mainContentData, setMainContentData }}>
      {children}
    </MainContentContext.Provider>
  );
};

export const useMainContent = () => useContext(MainContentContext);
